const prefix = "/hashtag";

export const HASHTAG_ENDPOINTS = {
  BASE: prefix,
  MOST_POPULAR: `${prefix}/most-popular`,
};

export const HASHTAG_QUERY = {
  GET_MOST_POPULAR: "GET_MOST_POPULAR",
  UPDATE_HASHTAG: "UPDATE_HASHTAG",
};
